import { render, staticRenderFns } from "./NotificationSettingForm.vue?vue&type=template&id=aa15b7ac&scoped=true"
import script from "./NotificationSettingForm.vue?vue&type=script&lang=js"
export * from "./NotificationSettingForm.vue?vue&type=script&lang=js"
import style0 from "./NotificationSettingForm.vue?vue&type=style&index=0&id=aa15b7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa15b7ac",
  null
  
)

export default component.exports